import React from 'react';
import { renderYesNo } from '../../utils/formatters';
import { parseLanguageList } from '../../utils/parsers';

/**
 * Component to display job metadata details
 * @param {Object} props - Component props
 * @param {Object} props.job - Job data object
 * @returns {JSX.Element} Job details component
 */
const JobDetails = ({ job }) => {
  const infoRowStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
    fontSize: "0.9em",
    alignItems: "center",
    marginBottom: "10px",
    color: "#ddd", // Light gray text for better readability
  };
  
  return (
    <div style={infoRowStyle}>
      <span>🌍 Country: {job.country}</span>
      <span>🏙️ City: {job.city}</span>
      <span>📊 Level: {job.level || "N/A"}</span>
      <span>⌛ Min Years: {job.minimumyearsexperience || "N/A"}</span>
      {job.grade && <span>📈 Grade: {job.grade}</span>}
      <span>🗓️ Date Posted: {job.datejobposted}</span>
      <span>📅 Date Closes: {job.datecloses || "N/A"}</span>
      <span>🌐 Remote: {renderYesNo(job.remote)}</span>
      <span>🎯 Internship: {renderYesNo(job.internship)}</span>
      <span>🎓 Education: {job.educationrequired || "N/A"}</span>
      <span>🗣️ Languages Required: {parseLanguageList(job.languagesrequired).join(", ") || "N/A"}</span>
      
      {/* Display CV Similarity if available */}
      {job.cv_similarity !== undefined && (
        <span>🧩 CV Match: {Math.round(job.cv_similarity * 100)}%</span>
      )}
    </div>
  );
};

export default JobDetails;